import {
  ADD_NETWORK,
  EDIT_NETWORK,
  DELETE_NETWORK,
  FETCH_NETWORKS
} from "../actions/actionTypes";

const defaultState = {
  //lista ze wszystkimi sieciami
  networkList: []
};

export default function networkReducer(state = defaultState, action) {
  switch (action.type) {
    case FETCH_NETWORKS: {
      return {
        ...state,
        networkList: action.payload
      };
    }
    case ADD_NETWORK:
      return {
        ...state,
        networkList: [...state.networkList, action.payload]
      };
    case EDIT_NETWORK:
      return {
        ...state,
        networkList: state.networkList.map(network =>
          network.id === action.payload.id ? action.payload : network
        )
      };
    case DELETE_NETWORK:
      return {
        ...state,
        networkList: state.networkList.filter(
          network => network.id !== action.payload
        )
      };
    default:
      return state;
  }
}
